// Larger event banner rendered inside the expanded venue card. Shows the
// soonest event plus a "+N more this week" hint when the venue has
// multiple events queued up.

import React from 'react';
import { PartyPopper } from 'lucide-react';
import { relativeEventLabel } from './EventsCarousel';
import { EVENT_CATEGORY_LABELS } from './eventCategoryLabels';

const font = "'Inria Serif', serif";

export function VenueEventBanner({ events }) {
  if (!events?.length) return null;
  const ev = events[0];
  const title = ev.display_title || ev.custom_category || EVENT_CATEGORY_LABELS[ev.category] || 'Event';
  const label = relativeEventLabel(ev);
  const isLive = label.startsWith('Live Now');
  const extra = events.length - 1;
  return (
    <div
      data-testid={`venue-event-banner-${ev.id}`}
      style={{
        display: 'flex', alignItems: 'center', gap: 12,
        padding: '12px 14px',
        borderRadius: 16,
        background: isLive
          ? 'linear-gradient(135deg, rgba(255, 80, 80, 0.10), rgba(255, 142, 56, 0.12))'
          : 'linear-gradient(135deg, rgba(112, 63, 246, 0.08), rgba(255, 142, 56, 0.08))',
        border: '1px solid rgba(112, 63, 246, 0.10)',
        marginBottom: 14,
      }}
    >
      <div style={{
        width: 38, height: 38, borderRadius: 12, flexShrink: 0,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        background: isLive ? 'rgba(255, 80, 80, 0.18)' : 'rgba(255, 142, 56, 0.18)',
        color: isLive ? '#C42626' : '#B0531A',
      }}>
        <PartyPopper size={18} strokeWidth={2.2} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        {/* Title can wrap to a second line; the time label stays on its
            own line so the ending hour is always readable for live
            events. */}
        <p style={{ margin: 0, fontFamily: font, fontSize: 15, fontWeight: 700, color: 'var(--text)', lineHeight: 1.18, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
          {title}
        </p>
        {label ? (
          <p style={{ margin: '3px 0 0', fontFamily: font, fontSize: 13, fontWeight: 700, color: isLive ? '#C42626' : '#7341FE', whiteSpace: 'nowrap' }}>
            {label}
          </p>
        ) : null}
        {ev.mini_description ? (
          <p style={{ margin: '3px 0 0', fontFamily: font, fontSize: 12.5, color: 'var(--text-2)', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', wordBreak: 'break-word', lineHeight: 1.35 }}>
            {ev.mini_description}
          </p>
        ) : null}
        {extra > 0 ? (
          <p style={{ margin: '3px 0 0', fontFamily: font, fontSize: 11.5, fontWeight: 700, color: 'var(--text-2)' }}>
            +{extra} more this week
          </p>
        ) : null}
      </div>
    </div>
  );
}
